module.exports = __webpack_public_path__ + "img/photo-long-6.155ae578.jpg";